import { render } from "./chips-msg-box.vue?vue&type=template&id=2b97f600&scoped=true&ts=true"
import script from "./chips-msg-box.vue?vue&type=script&lang=ts"
export * from "./chips-msg-box.vue?vue&type=script&lang=ts"

import "./chips-msg-box.vue?vue&type=style&index=0&id=2b97f600&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b97f600"]])

export default __exports__